module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Italic.eot?v=4c4b7fb2750f6abe76a41e963dc7822b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Italic.eot?
// module id = 649
// module chunks = 0